export function getRatingColor(rating: number): string {
  switch (true) {
    case rating < 6:
      return "#eb1b24"; // 0 - 5.9
    case rating < 6.5:
      return "#ff7a01"; // 6 - 6.4
    case rating < 7: // 6.5 - 6.9
      return "#f4ba02";
    case rating < 8: // 7 - 7.9
      return "#c0cc00";
    case rating < 9: // 8 - 8.9
      return "#5cb400";
    default: // 9 - 10
      return "#009f9e";
  }
}
